module.exports = __webpack_public_path__ + "static/media/pic-az.9fbb537f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-az.svg
// module id = 277
// module chunks = 0